import { useState, useEffect } from 'react';

export default function ThemeToggle() {
  const [isDark, setIsDark] = useState(false);

  // On mount, check local storage or default to light
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') {
      setIsDark(true);
      document.documentElement.classList.add('dark');
    }
  }, []);

  const toggleTheme = () => {
    setIsDark(!isDark);
    document.documentElement.classList.toggle('dark');
  };

  return (
    <button
      onClick={toggleTheme}
      title="Theme toggle"
      className="hidden sm:block px-4 transition text-yellow text-xl"
    >
      {isDark ? <i className="bx bx-sun" /> : <i className="bx bx-moon"></i>}
    </button>
  );
}
